// import {HTTPServer, baseURL} from '@/common/js/ajax'
import * as types from '../mutations-types'
// import router from '../../router'
// import axios from 'axios'
// import Vue from 'vue'
// import tool from '@/common/js/tool.js'
// const _that = new Vue({router})
// const dragOptions = {
//   animation: 100,
//   group: { name: 'compontents', pull: true, put: true },
//   ghostClass: 'ghost',
//   filter: '.no-drag'
// }
// initial state
// shape: [{ id, quantity }]
const state = {
  custom_page: '',
  custom_layout: {},
  enable_layout: {},
  preview_layout: {},
  child_custom_layout: {},
  child_unused_layout: {},
  design_change: {},
  custom_appearance: {},
  custom_module_list: [],
  app_list_layout: false,
  select_hide_field: [],
  select_show_field: [],
  linkage_fields_data: {}, // 联动数据
  signature_emit_event: {}, // 手写签名完成事件
  tab_screen_data: {}, // 页签筛选
  update_custom_detail: '', // 更新自定义详情
  update_custom_list: {}, // 跟新自定义列表
  set_check_empty: '', // 清空选择项
  custom_batch_linkage: {}, // 批量联动
  business_flow_reference: {}, // 业务流程选定关联关系
  updata_reference_two_create: {}, // 关联关系弹窗新建后
  update_subform_repeat: {}, // 子表单查重设置
  set_hjc_callback_phone: {}, // 华巨臣通信回调
  set_main_to_subform_batchlinkage: {}, // 主表触发子表单联动
  update_subform_style: {},
  custom_app_module_data: {},
  cloum_screen_set_data: {}, // 列字段筛选保存
  custom_event_update: {},
  custom_send_reference: {}
}

// getters
const getters = {
  custom_page: state => state.custom_page,
  custom_layout: state => state.custom_layout,
  enable_layout: state => state.enable_layout,
  preview_layout: state => state.preview_layout,
  design_change: state => state.design_change,
  custom_appearance: state => state.custom_appearance,
  child_custom_layout: state => state.child_custom_layout,
  child_unused_layout: state => state.child_unused_layout,
  custom_module_list: state => state.custom_module_list,
  select_hide_field: state => state.select_hide_field,
  select_show_field: state => state.select_show_field,
  linkage_fields_data: state => state.linkage_fields_data,
  signature_emit_event: state => state.signature_emit_event
}

// actions
// const actions = {
//   getEnableLayout: ({ commit, state }, data) => {
//     let requestHeader = JSON.parse(localStorage.getItem('requestHeader'))
//     requestHeader.sign = tool.Encrypt()
//     axios({
//       method: 'get',
//       url: 'layout/getEnableLayoutBack',
//       baseURL: baseURL,
//       params: data,
//       headers: requestHeader
//     }).then((res) => {
//       if (res.data.response.code === 'common.sucess') {
//         if (!res.data || !res.data.data || JSON.stringify(res.data.data) === '{}') {
//           // _that.$alert('网络连接失败，请检查您的网络重新访问。', '提示', {
//           _that.$alert(window.vm.$i18n.t('custom_backstage.networkFialAgainCheck'), window.vm.$i18n.t('base_common.tips'), {
//             confirmButtonText: window.vm.$i18n.t('base_common.determine'),
//             type: 'warning',
//             showClose: false,
//             callback: action => {
//               _that.$router.push({path: '/backend/module?id=' + _that.$route.query.appId})
//             }
//           })
//         } else {
//           if (!res.data.data.new) {
//             res.data.data = tool.judgeZipOrUnzip(res.data.data, 'layout/getEnableLayoutBack', 1)
//             res.data.data.layout.map((item, index) => {
//               item.dragOptions = dragOptions
//               if (item.name !== 'systemInfo' && item.name !== 'webformInfo') {
//                 item.rows.map((e, index2) => {
//                   if (e.name !== 'personnel_principal') {
//                     e.name = e.type + '_' + (new Date().getTime() + index2 + 10)
//                   }
//                   if (e.type === 'subform') {
//                     if (e.componentList && e.componentList.length > 0) {
//                       e.componentList.map((v, k) => {
//                         v.name = 'subform_' + v.type + '_' + (new Date().getTime() + index2 + 10 + k)
//                       })
//                     }
//                   }
//                 })
//               }
//               item.rows.map((e, index2) => {
//                 // 去掉组件焦点
//                 e.active = '0'
//               })
//             })
//           }
//           if (!res.data.data.listPageTypes) {
//             res.data.data.listPageTypes = []
//           }
//           if (!res.data.data.singleFieldEdit) {
//             res.data.data.singleFieldEdit = '1'
//           }
//           res.data.data.layout.map((item, index) => {
//             item.rows.map((e, index2) => {
//               if (e.type === 'subform' && !e.field.subformSort) { // 子表单拖动排序
//                 e.field.subformSort = '1'
//               }
//               if (e.type === 'subform' && !e.dynamic) { // 子表单动态记录
//                 e.is_dynamic = 0
//                 e.dynamic = {unique: '', fields: ''}
//               }
//               if (!e.field.detailView) {
//                 e.field.detailView = '1'
//               }
//               if (e.type === 'text' && !e.formatCheck) {
//                 e.formatCheck = '0'
//               }
//               if (e.type === 'subform') {
//                 e.componentList.map((v1, k1) => {
//                   if (v1.type === 'reference' && !v1.field.repeatCheck) {
//                     v1.field.repeatCheck = '0'
//                   }
//                   if (v1.type === 'text' && !v1.formatCheck) {
//                     v1.formatCheck = '0'
//                   }
//                 })
//               }
//             })
//           })
//           commit('CUSTOM_LAYOUT', res.data.data)
//           commit('PREVIEW_LAYOUT', res.data.data)
//           commit('DESIGN_CHANGE', res.data.data)
//           let appearance = res.data.data.appearance
//           commit('CUSTOM_APPEARANCE', appearance)
//         }
//       } else {
//         // _that.$alert('网络连接失败，请检查您的网络重新访问。', '提示', {
//         _that.$alert(window.vm.$i18n.t('custom_backstage.networkFialAgainCheck'), window.vm.$i18n.t('base_common.tips'), {
//           confirmButtonText: window.vm.$i18n.t('base_common.determine'),
//           type: 'warning',
//           showClose: false,
//           callback: action => {
//             _that.$router.push({path: '/backend/module?id=' + _that.$route.query.appId})
//           }
//         })
//       }
//     })
//   },
//   getDisbaleLayout: ({ commit, state }, data) => {
//     // HTTPServer.getDisableLayout(data, 'Loading').then((res) => {
//     HTTPServer.getDisableLayoutBack(data, 'Loading').then((res) => {
//       res.rows && res.rows.map((e, index2) => {
//         if (e.type === 'subform') {
//           e.componentList.map((v1, k1) => {
//             if (v1.type === 'reference' && !v1.field.repeatCheck) {
//               v1.field.repeatCheck = '0'
//             }
//           })
//         }
//       })
//       commit('ENABLE_LAYOUT', {rows: res.rows})
//     })
//   }
// }

// mutations
const mutations = {
  [types.CUSTOM_PAGE](state, layout) {
    state.custom_page = layout
  },
  [types.CUSTOM_LAYOUT](state, layout) {
    state.custom_layout = layout
  },
  [types.ENABLE_LAYOUT](state, layout) {
    state.enable_layout = layout
  },
  [types.PREVIEW_LAYOUT](state, layout) {
    state.preview_layout = layout
  },
  [types.DESIGN_CHANGE](state, layout) {
    state.design_change = layout
  },
  [types.CUSTOM_APPEARANCE](state, layout) {
    state.custom_appearance = layout
  },
  [types.CHILD_CUSTOM_LAYOUT](state, layout) {
    state.child_custom_layout = layout
  },
  [types.CHILD_UNUSED_LAYOUT](state, layout) {
    state.child_unused_layout = layout
  },
  [types.APP_LSIT_LAYOUT](state, layout) {
    state.app_list_layout = layout
  },
  [types.CUSTOM_MODULE_LIST](state, layout) {
    state.custom_module_list = layout
  },
  [types.SELECT_HIDE_FIELD](state, layout) {
    state.select_hide_field = layout
  },
  [types.SELECT_SHOW_FIELD](state, layout) {
    state.select_show_field = layout
  },
  [types.LINKAGE_FIELDS_DATA](state, layout) {
    state.linkage_fields_data = layout
  },
  [types.SIGNATURE_EMIT_EVENT](state, layout) {
    state.signature_emit_event = layout
  },
  [types.TAB_SCREEN_DATA](state, data) {
    state.tab_screen_data = data
  },
  [types.UPDATE_CUSTOM_DETAIL](state, data) {
    state.update_custom_detail = data
  },
  [types.UPDATE_CUSTOM_LIST](state, data) {
    state.update_custom_list = data
  },
  [types.SET_CHECK_EMPTY](state, data) {
    state.set_check_empty = data
  },
  [types.CUSTOM_BATCH_LINKAGE](state, data) {
    state.custom_batch_linkage = data
  },
  [types.BUSINESS_FLOW_REFERENCE](state, data) {
    state.business_flow_reference = data
  },
  [types.UPDATE_REFERENCE_CREATE](state, data) {
    state.updata_reference_two_create = data
  },
  [types.UPDATE_SUBFORM_REPEAT](state, data) {
    state.update_subform_repeat = data
  },
  [types.SET_HJC_CALLBACK_PHONE](state, data) {
    state.set_hjc_callback_phone = data
  },
  [types.SET_MAIN_TO_SUBFORM_BATCHLINKAGE](state, data) {
    state.set_main_to_subform_batchlinkage = data
  },
  [types.UPDATE_SUBFORM_STYLE](state, data) {
    state.update_subform_style = data
  },
  [types.SET_CUSTOM_APP_MODULE_DATA](state, data) {
    state.custom_app_module_data = data
  },
  [types.CLOUM_SCREEN_SET_DATA](state, data) {
    state.cloum_screen_set_data = data
  },
  [types.CUSTOM_EVENT_UPDATE](state, data) {
    state.custom_event_update = data
  },
  [types.CUSTOM_SEND_REFERENCE](state, data) {
    state.custom_send_reference = data
  }
}

export default {
  state,
  getters,
  // actions,
  mutations
}
